<template>
    <app-title />
    <!-- eslint-disable max-len -->
    <navbar :app="$page.props.app"
            :route-name="$page.props.routeName"
            :trans="$page.props.trans" />
    <header class="max-h-[calc(100vh-4rem)] bg-cover bg-center bg-no-repeat relative overflow-hidden"
            :style="hasComicShowHeader ? {backgroundImage: `url(${$page.props.comic.path})`} : ''"
            :class="{
                'header h-[calc(100vh-4rem)]': !hasSmallHeader && !hasComicHeader && !hasComicShowHeader && !hasFpsHeader,
                'header-sm h-36 sm:h-52': hasSmallHeader && !hasComicHeader && !hasComicShowHeader && !hasFpsHeader,
                'h-36 sm:h-52 relative': !hasSmallHeader && !hasComicHeader && hasComicShowHeader && !hasFpsHeader
            }">
        <div v-if="hasComicShowHeader" class="absolute inset-0 bg-slate-800/85 backdrop-blur-sm [@supports(backdrop-filter:blur(0))]:bg-slate-800/65"></div>
        <div class="h-full">
            <video v-if="hasComicHeader"
                   class="w-full"
                   autoplay
                   muted
                   loop
                   playsinline>
                <source :src="$page.props.assets['images/header-comic.mp4']" type="video/mp4">
            </video>
            <video v-if="hasFpsHeader"
                   class="w-full"
                   autoplay
                   muted
                   loop
                   playsinline>
                <source :src="$page.props.assets['images/header-fps.mp4']" type="video/mp4">
            </video>
            <div v-if="$page.props.routeName === 'home'"
                 class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 grid grid-cols-2 gap-5 min-w-[16rem] max-w-4xl md:gap-10">
                <inertia-link class="group block relative rounded-3xl border border-slate-800 shadow-lg"
                              :href="route('comic', $page.props.app.locale)">
                    <div class="absolute -inset-[2px] rounded-3xl border-2 border-transparent opacity-0 [background:linear-gradient(var(--color-slate-800),var(--color-slate-800))_padding-box,linear-gradient(to_top,var(--color-indigo-400),var(--color-cyan-400),var(--color-sky-500))_border-box] group-hover:opacity-100"></div>
                    <img class="relative rounded-3xl"
                         :src="$page.props.assets['images/pmm-cover.png']"
                         alt="">
                </inertia-link>
                <inertia-link class="group block relative rounded-3xl border border-slate-800"
                              :href="route('fps', $page.props.app.locale)">
                    <div class="absolute -inset-[2px] rounded-3xl border-2 border-transparent opacity-0 [background:linear-gradient(var(--color-slate-800),var(--color-slate-800))_padding-box,linear-gradient(to_top,var(--color-indigo-400),var(--color-cyan-400),var(--color-sky-500))_border-box] group-hover:opacity-100"></div>
                    <img class="relative rounded-3xl"
                         :src="$page.props.assets['images/moc-cover.png']"
                         alt="">
                </inertia-link>
            </div>
            <div v-if="hasFpsHeader"
                 class="hidden absolute left-20 top-1/2 -translate-y-1/2 w-32 md:block lg:w-48 xl:w-72 2xl:w-96">
                <div class="block rounded-3xl border border-slate-800">
                    <img class="rounded-3xl"
                         :src="$page.props.assets['images/moc-cover.png']"
                         alt="">
                </div>
            </div>
            <div v-if="hasFpsHeader || $page.props.routeName === 'home'"
                 class="hidden absolute left-1/2 -translate-x-1/2 bottom-8 md:block">
                <chevron-down-icon class="h-10 w-10 text-white animate-bounce" />
            </div>
        </div>
    </header>
    <slot></slot>
    <footer class="container border-t border-slate-300/10 mx-auto py-10 px-5 flex flex-col items-center md:flex-row">
        <div class="text-slate-500 mb-5 md:mr-auto md:mb-0">
            <p class="text-sm" v-html="$page.props.app.copyright"></p>
            <div class="flex justify-center md:justify-start space-x-3 mt-3">
                <inertia-link class="btn-dark flex items-center justify-center text-sm font-semibold px-3 py-1.5 bg-slate-800 text-slate-400 hover:bg-slate-700"
                              :href="route('about', $page.props.app.locale)">
                    {{ $page.props.trans['messages.about'] }}
                </inertia-link>
                <inertia-link class="btn-dark flex items-center justify-center text-sm font-semibold px-3 py-1.5 bg-slate-800 text-slate-400 hover:bg-slate-700"
                              :href="route('contact', $page.props.app.locale)">
                    {{ $page.props.trans['messages.contact'] }}
                </inertia-link>
                <button class="btn-dark flex items-center justify-center text-sm font-semibold px-3 py-1.5 bg-slate-800 text-slate-400 hover:bg-slate-700"
                        @click="dataProcessingOpen = true">
                    Data Processing
                </button>
            </div>
        </div>
        <div class="flex items-center space-x-4">
            <a class="text-blue-500 hover:text-blue-600"
               href="https://www.facebook.com/groups/207861980435264/?source_id=1509842252669349"
               target="_blank">
                <svg class="h-6 w-6"
                     xmlns="http://www.w3.org/2000/svg"
                     fill="currentColor"
                     viewBox="0 0 16 16">
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                </svg>
            </a>
            <a class="text-red-500 hover:text-red-600"
               href="https://www.youtube.com/channel/UCO0qiBKrOpV89AIQ-jXZ4gw/featured"
               target="_blank">
                <svg class="h-6 w-6"
                     xmlns="http://www.w3.org/2000/svg"
                     fill="currentColor"
                     viewBox="0 0 16 16">
                    <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                </svg>
            </a>
            <a class="text-yellow-500 hover:text-yellow-600"
               href="https://www.instagram.com/thelegionforever/"
               target="_blank">
                <svg class="h-6 w-6"
                     xmlns="http://www.w3.org/2000/svg"
                     fill="currentColor"
                     viewBox="0 0 16 16">
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                </svg>
            </a>
        </div>
    </footer>
    <TransitionRoot as="template"
                    :show="dataProcessingOpen">
        <HeadlessDialog as="div"
                        class="relative z-20"
                        @close="dataProcessingOpen = false">
            <TransitionChild as="template"
                             enter="ease-out duration-300"
                             enter-from="opacity-0"
                             enter-to="opacity-100"
                             leave="ease-in duration-200"
                             leave-from="opacity-100"
                             leave-to="opacity-0">
                <div class="fixed inset-0 bg-black/50 transition-opacity"></div>
            </TransitionChild>
            <div class="fixed z-20 inset-0 overflow-y-auto">
                <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <TransitionChild as="template"
                                     enter="ease-out duration-300"
                                     enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                     enter-to="opacity-100 translate-y-0 sm:scale-100"
                                     leave="ease-in duration-200"
                                     leave-from="opacity-100 translate-y-0 sm:scale-100"
                                     leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative bg-slate-800 rounded-3xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-2xl sm:w-full">
                            <div class="bg-slate-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div class="mt-3 text-center sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3"
                                                 class="text-xl text-center bg-linear-to-r from-indigo-200 via-sky-400 to-indigo-200 bg-clip-text text-transparent mb-10 xl:text-2xl">
                                        {{ $page.props.trans['validation.attributes.gdpn'] }}
                                    </DialogTitle>
                                    <div class="prose mx-auto" v-html="$page.props.textBlocks.PRIVACY"></div>
                                </div>
                            </div>
                            <div class="bg-slate-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <button ref="cancelButtonRef"
                                        type="button"
                                        class="btn-sky font-semibold mt-3 w-full sm:mt-0 sm:ml-3 sm:w-auto"
                                        @click="dataProcessingOpen = false">
                                    {{ $page.props.trans['messages.close'] }}
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </HeadlessDialog>
    </TransitionRoot>
    <!-- eslint-enable max-len -->
</template>

<script setup>
import {
    ChevronDownIcon
} from '@heroicons/vue/24/solid';

import {
    Dialog as HeadlessDialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot
} from '@headlessui/vue';

import { computed, ref, useAttrs } from 'vue';
import Navbar from './Navbar.vue';

const dataProcessingOpen = ref(false);
const attrs = useAttrs();

const hasSmallHeader = computed(() => attrs.routeName !== 'home'
    && attrs.routeName !== 'comic'
    && attrs.routeName !== 'comic_show'
    && attrs.routeName !== 'fps');

const hasComicHeader = computed(() => attrs.routeName === 'comic'
    || attrs.routeName === 'comic_gallery');

const hasComicShowHeader = computed(() => attrs.routeName === 'comic_show');

const hasFpsHeader = computed(() => attrs.routeName === 'fps');

document.addEventListener('open-data-processing', () => {
    dataProcessingOpen.value = true;
}, false);
</script>
